import get from 'lodash/get';
import { wowsEntities } from '@wg/wows-entities';

import { shipFeaturesReducerActions } from './shipFeaturesSlice';

import type { Thunk } from '~/store';
import type { IFeaturesItem, ShipFeaturesMap } from '~/types';
import type { ApolloQueryResult } from 'apollo-client';

import vortexClient from '~/vortexClient';
import { features } from '~/queries/features';
import { LocalStorageHelper } from '~/utils/storage';

type ShipFeaturesStorage = {
    version: string,
    lang: string,
    data: ShipFeaturesMap,
};


// Reducer actions
export const {
    addFeaturesToStore,
} = shipFeaturesReducerActions;


// Thunk actions
export const loadFeatures = (): Thunk => async (dispatch) => {
    const data: { shipFeaturesMap: ShipFeaturesMap } = {
        shipFeaturesMap: {},
    };

    const shipFeatureStorage: null | ShipFeaturesStorage = LocalStorageHelper.get('shipFeatures') as ShipFeaturesStorage;

    const version = wowsEntities.settings.gameVersion;
    const languageCode: string = get(window, 'dockyard.settings.languageCode', '');

    if (
        (shipFeatureStorage?.version === version || !version)
        && shipFeatureStorage?.lang === languageCode
        && shipFeatureStorage?.data
    ) {
        dispatch(addFeaturesToStore(shipFeatureStorage.data));
    } else {
        await vortexClient
            .get()
            .query({
                query: features,
                variables: {
                    lang: languageCode,
                },
            })
            .then((response: ApolloQueryResult<{ features?: IFeaturesItem[] }>) => {
                response.data?.features?.forEach((feature: IFeaturesItem) => {
                    data.shipFeaturesMap[feature.id] = feature;
                });
            })
            .catch(() => {
                console.error('response not successful for item');
            });

        LocalStorageHelper.set('shipFeatures', { version, lang: languageCode, data: data.shipFeaturesMap });

        dispatch(addFeaturesToStore(data.shipFeaturesMap));
    }
};
